import EventList from "../../slices/event/EventList";
import CategoryList from "../../slices/event/CategoryList";
import EventDetails from "../../slices/event/EventDetails";
import RegisteredEventList from "../../slices/event/RegisteredEventList";
import UpcomingEventList from "../../slices/event/UpcomingEventList";
import PastEventList from "../../slices/event/PastEventList";
import EventByDate from "../../slices/event/EventByDate";
import Leaderboard from "../../slices/event/Leaderboard";

const eventReducer = {
    eventList: EventList,
    categoryList: CategoryList,
    eventDetails: EventDetails,
    registeredEventList: RegisteredEventList,
    upcomingEventList: UpcomingEventList,
    pastEventList: PastEventList,
    eventByDate: EventByDate,
    leaderboardList: Leaderboard,
};

export default eventReducer;